import type { ISiteApis, IWixAPI, SiteStructure } from '@wix/yoshi-flow-editor';

import { GROUPS_APP_DEFINITION_ID } from '../constants';

/**
 * Resolve verticals base urls
 * please bear in mind that object keys should be named the same as routes names.
 * router will inject baseUrls to them during registration stage
 */
export async function resolveVerticalsBaseUrls(api: IWixAPI) {
  const siteStructure = await getSiteStructure(api.site);

  return {
    siteStructure,
    group: removeTrailingSlash(getGroupPageUrl(siteStructure)),
    groups: removeTrailingSlash(getGroupListPageUrl(siteStructure)),
  };
}

function getGroupPageUrl(siteStructure: SiteStructure) {
  return getComponentUrl(
    siteStructure,
    {
      sectionId: 'group',
      appDefinitionId: GROUPS_APP_DEFINITION_ID,
    },
    '/group',
  );
}

function getGroupListPageUrl(siteStructure: SiteStructure) {
  return getComponentUrl(
    siteStructure,
    {
      sectionId: 'groups',
      appDefinitionId: GROUPS_APP_DEFINITION_ID,
    },
    '/groups',
  );
}

async function getSiteStructure(site: ISiteApis): Promise<SiteStructure> {
  try {
    return site.getSiteStructure({
      includePageId: true,
    });
  } catch {
    return {
      pages: [],
      prefixes: [],
      lightboxes: [],
    };
  }
}

function getComponentUrl(
  siteStructure: SiteStructure,
  sectionIdentifier: {
    appDefinitionId: string;
    sectionId: 'groups' | 'group' | 'membership_plan_picker_tpa' | 'about';
  },
  fallback: string,
) {
  const { pages } = siteStructure;
  const [page] = pages.filter(
    (page: any) =>
      page.tpaPageId === sectionIdentifier.sectionId &&
      page.applicationId === sectionIdentifier.appDefinitionId,
  );

  if (!page) {
    return fallback;
  }

  return page.isHomePage ? '/' : page.url || fallback;
}

function removeTrailingSlash(url: string) {
  return url.replace(/(\/)\/+/g, '/');
}
